import { Component, default as React } from "react";
import { css, cx } from "emotion";
const floatingContainerClass = css({
    position: "sticky",
});
export class FloatingContainer extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        const offsetClass = css({
            top: `${this.props.offsetTop}px`,
        });
        return (React.createElement("div", { className: cx(floatingContainerClass, offsetClass) }, this.props.children));
    }
}
export default FloatingContainer;
//# sourceMappingURL=floatingcontainer.js.map